import { render, staticRenderFns } from "./AdminTestfields.vue?vue&type=template&id=d36a2cbe&scoped=true"
import script from "./AdminTestfields.vue?vue&type=script&lang=js"
export * from "./AdminTestfields.vue?vue&type=script&lang=js"
import style0 from "./AdminTestfields.vue?vue&type=style&index=0&id=d36a2cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36a2cbe",
  null
  
)

export default component.exports